export const checkLength = (value: string, length: number) => {
   if (value.replace(/\s/g, '').length > length) {
      return value.slice(0, value.length-1);
   } else {
      return value;
   }
};
